import { render, staticRenderFns } from "./GallerySelector.vue?vue&type=template&id=6d905b96&scoped=true"
import script from "./GallerySelector.vue?vue&type=script&lang=js"
export * from "./GallerySelector.vue?vue&type=script&lang=js"
import style0 from "./GallerySelector.vue?vue&type=style&index=0&id=6d905b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d905b96",
  null
  
)

export default component.exports